import { render, staticRenderFns } from "./MasterData.vue?vue&type=template&id=4eccc1cc&scoped=true"
import script from "./MasterData.vue?vue&type=script&lang=ts"
export * from "./MasterData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eccc1cc",
  null
  
)

export default component.exports